import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg'

export default CloseIcon
